import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import { ReactComponent as FilterIcon } from '../../../resource/FilterIcon.svg';
import styles from './TableFilterBtn.module.scss';

const TableFilterBtn = ({ filtered = false, className, ...props }) => {
  return (
    <Button {...props} shape="circle" className={cn(styles.root, className)}>
      <FilterIcon
        className={cn(styles.icon, { [styles.filtered]: filtered })}
      />
    </Button>
  );
};

export default TableFilterBtn;
